/* ============================================================
   INDSO SKIN QUIZ — STOREFRONT (browser port of the scoring engine)
   Engine data/logic ported 1:1 from indso_quiz_backend.js, plus a
   self-contained UI controller. No build step / framework required.
   ============================================================ */
(function () {
  'use strict';

  /* ----- SKU CATALOGUE ----- */
  var SKUS = {
    APG0000: { name: 'White Tea Gel', time: 'Anytime', tagline: 'antioxidant calm + barrier' },
    TMG0000: { name: 'Tropical Mixed Fruit Gel', time: 'Anytime', tagline: 'fruit-acid glow + clarify' },
    TMG0001: { name: 'Turmeric Milk Gel', time: 'Night', tagline: 'comfort glow + even tone' },
    TMG0002: { name: 'Orange Vitamin C Gel', time: 'Morning', tagline: 'vitamin C bright + clear' },
    APG0002: { name: 'Anti-Pollution Gel Cream', time: 'Morning', tagline: 'urban shield + brightening' },
    BLG0000: { name: 'Black Lotus Night Gel', time: 'Night', tagline: 'night repair + retinol lift' },
    AHG0000: { name: 'Ashwagandha Hydration Gel', time: 'Anytime', tagline: 'barrier calm + hydration' },
    'C&CG0001': { name: 'Coffee & Cocoa Gel', time: 'Morning', tagline: 'energise + de-puff + glow' }
  };

  /* ----- QUESTION DEFINITIONS ----- */
  var QUESTIONS = [
    {
      id: 'q1_age', question: 'How old are you?', type: 'single',
      options: [
        { label: 'Under 20', value: 'under20' },
        { label: '20–29', value: '20_29' },
        { label: '30–39', value: '30_39' },
        { label: '40–49', value: '40_49' },
        { label: '50+', value: '50plus' }
      ]
    },
    {
      id: 'q2_skin_type', question: 'How would you describe your skin most days?', type: 'single',
      options: [
        { label: 'Oily or acne-prone', value: 'oily' },
        { label: 'Combination (oily T-zone, normal elsewhere)', value: 'combo' },
        { label: 'Normal / balanced', value: 'normal' },
        { label: 'Dry or dehydrated', value: 'dry' },
        { label: 'Sensitive / easily irritated', value: 'sensitive' }
      ]
    },
    {
      id: 'q3_goals', question: 'What are your top skin goals right now? (Choose up to 3)', type: 'multi', maxSelect: 3,
      options: [
        { label: 'Brightening dullness / dark spots', value: 'brightening' },
        { label: 'Calming redness or sensitivity', value: 'calming' },
        { label: 'Clearing breakouts / clogged pores', value: 'clearing' },
        { label: 'Deep, lasting hydration', value: 'hydration' },
        { label: 'Strengthening skin barrier', value: 'barrier' },
        { label: 'Smoothing tiny bumps / uneven texture', value: 'texture' },
        { label: 'Firming, overnight repair / fine lines', value: 'firming' }
      ]
    },
    {
      id: 'q4_timing', question: 'When do you usually apply skincare?', type: 'single',
      options: [
        { label: 'Morning only', value: 'morning' },
        { label: 'Night only', value: 'night' },
        { label: 'Morning and night', value: 'both' },
        { label: 'Whenever I remember', value: 'whenever' }
      ]
    },
    {
      id: 'q5_breakouts', question: 'How often do you get breakouts or clogged pores?', type: 'single',
      options: [
        { label: 'Very often (every week)', value: 'veryoften' },
        { label: 'Sometimes, mostly on T-zone', value: 'sometimes' },
        { label: 'Rarely', value: 'rarely' },
        { label: 'Almost never', value: 'never' }
      ]
    },
    {
      id: 'q6_reactivity', question: 'How reactive is your skin to products or weather?', type: 'single',
      options: [
        { label: 'New products often sting or burn', value: 'stings' },
        { label: 'Heat / sun easily makes me red or itchy', value: 'heatsun' },
        { label: 'Pollution / dust makes my skin feel stressed', value: 'pollution' },
        { label: 'Fragrance often bothers me', value: 'fragrance' },
        { label: 'None of these — my skin is quite resilient', value: 'resilient' }
      ]
    },
    {
      id: 'q7_environment', question: 'What best describes your daily environment?', type: 'single',
      options: [
        { label: 'Hot & humid, lots of time outdoors', value: 'humid' },
        { label: 'Polluted city commute (traffic, dust, metro)', value: 'polluted' },
        { label: 'Mostly indoors in AC / dry office air', value: 'ac' },
        { label: 'A mix of indoor and outdoor through the day', value: 'mixed' }
      ]
    },
    {
      id: 'q8_steps', question: 'How many steps do you realistically enjoy?', type: 'single',
      options: [
        { label: '1–2 steps only (quick & minimal)', value: 'minimal' },
        { label: '3 steps is fine', value: 'three' },
        { label: 'I enjoy a longer ritual with multiple steps', value: 'ritual' }
      ]
    },
    {
      id: 'q9_spf', question: 'Do you wear SPF and/or makeup on most days?', type: 'single',
      options: [
        { label: 'Yes, almost every day', value: 'yes' },
        { label: 'Sometimes', value: 'sometimes' },
        { label: 'Rarely or never', value: 'never' }
      ]
    },
    {
      id: 'q10_hormones', question: 'Do hormones or cycle changes affect your skin?', type: 'single',
      options: [
        { label: 'Yes, I get cycle-related breakouts or flare-ups', value: 'yes' },
        { label: 'Sometimes, but not every month', value: 'sometimes' },
        { label: "I'm perimenopausal or menopausal", value: 'meno' },
        { label: "No, I don't notice a big change", value: 'no' }
      ]
    }
  ];

  /* ----- SCORING MATRIX ----- */
  var SCORING_MATRIX = {
    q1_age: {
      under20: { TMG0000: 2, TMG0002: 2, APG0000: 1 },
      '20_29': { TMG0002: 3, APG0002: 2, 'C&CG0001': 2, TMG0000: 1 },
      '30_39': { APG0002: 3, TMG0001: 2, AHG0000: 2, BLG0000: 1 },
      '40_49': { BLG0000: 4, TMG0001: 3, AHG0000: 2 },
      '50plus': { BLG0000: 5, TMG0001: 3, AHG0000: 2 }
    },
    q2_skin_type: {
      oily: { TMG0000: 4, TMG0002: 4, 'C&CG0001': 3, APG0002: 2 },
      combo: { TMG0002: 3, TMG0000: 3, APG0002: 3, 'C&CG0001': 2 },
      normal: { APG0000: 3, AHG0000: 3, TMG0001: 2, APG0002: 2 },
      dry: { AHG0000: 5, TMG0001: 4, BLG0000: 3, APG0000: 2 },
      sensitive: { AHG0000: 5, APG0000: 4, TMG0001: 3, BLG0000: 2 }
    },
    q3_goals: {
      brightening: { TMG0002: 4, TMG0000: 3, 'C&CG0001': 3, TMG0001: 2, APG0002: 2 },
      calming: { AHG0000: 4, APG0000: 4, TMG0001: 3, BLG0000: 2 },
      clearing: { TMG0000: 4, TMG0002: 3, 'C&CG0001': 3, APG0002: 2 },
      hydration: { AHG0000: 4, TMG0001: 3, APG0000: 3, BLG0000: 2 },
      barrier: { AHG0000: 4, APG0000: 3, TMG0001: 2, APG0002: 2 },
      texture: { TMG0000: 4, TMG0002: 3, 'C&CG0001': 3, BLG0000: 2 },
      firming: { BLG0000: 5, TMG0001: 3, AHG0000: 2 }
    },
    q4_timing: {
      morning: { TMG0002: 3, APG0002: 3, 'C&CG0001': 3 },
      night: { BLG0000: 4, TMG0001: 3, AHG0000: 2 },
      both: { TMG0002: 2, APG0002: 2, BLG0000: 2, TMG0001: 2, AHG0000: 1 },
      whenever: { AHG0000: 3, APG0000: 3, TMG0001: 2 }
    },
    q5_breakouts: {
      veryoften: { TMG0000: 5, TMG0002: 4, 'C&CG0001': 3, APG0002: 2 },
      sometimes: { TMG0000: 3, TMG0002: 3, APG0002: 2, 'C&CG0001': 2 },
      rarely: { AHG0000: 2, APG0000: 2, TMG0001: 2 },
      never: { AHG0000: 2, APG0000: 3, BLG0000: 2, TMG0001: 2 }
    },
    q6_reactivity: {
      stings: { APG0000: 5, AHG0000: 4, TMG0001: 2 },
      heatsun: { APG0000: 4, AHG0000: 3, APG0002: 3 },
      pollution: { APG0002: 5, 'C&CG0001': 3, TMG0002: 2 },
      fragrance: { APG0000: 4, AHG0000: 3, TMG0001: 2 },
      resilient: { TMG0002: 2, APG0002: 2, 'C&CG0001': 2, TMG0000: 2 }
    },
    q7_environment: {
      humid: { TMG0000: 4, TMG0002: 3, APG0002: 2, 'C&CG0001': 2 },
      polluted: { APG0002: 5, 'C&CG0001': 3, TMG0002: 3 },
      ac: { AHG0000: 4, TMG0001: 3, BLG0000: 2 },
      mixed: { AHG0000: 2, APG0002: 2, APG0000: 2, TMG0002: 2 }
    },
    q8_steps: {
      minimal: { AHG0000: 3, APG0000: 3, 'C&CG0001': 2 },
      three: { TMG0002: 2, APG0002: 2, TMG0001: 2, AHG0000: 1 },
      ritual: { BLG0000: 3, TMG0001: 3, APG0002: 2, TMG0002: 2 }
    },
    q9_spf: {
      yes: { TMG0002: 3, APG0002: 3, 'C&CG0001': 2 },
      sometimes: { AHG0000: 2, APG0000: 2, TMG0001: 2 },
      never: { BLG0000: 2, TMG0001: 3, AHG0000: 2 }
    },
    q10_hormones: {
      yes: { TMG0000: 3, TMG0002: 3, AHG0000: 2, 'C&CG0001': 2 },
      sometimes: { AHG0000: 2, APG0000: 2, TMG0001: 2 },
      meno: { BLG0000: 4, TMG0001: 3, AHG0000: 2 },
      no: { APG0002: 2, 'C&CG0001': 2, TMG0002: 2 }
    }
  };

  /* ============================================================
     SCORING ENGINE (ported)
     ============================================================ */
  function scoreQuiz(answers) {
    var scores = Object.keys(SKUS).reduce(function (acc, sku) { acc[sku] = 0; return acc; }, {});

    Object.keys(answers).forEach(function (qId) {
      var qMatrix = SCORING_MATRIX[qId];
      if (!qMatrix) return;
      var answer = answers[qId];
      var answerArr = Array.isArray(answer) ? answer : [answer];
      answerArr.forEach(function (val) {
        var pointMap = qMatrix[val];
        if (!pointMap) return;
        Object.keys(pointMap).forEach(function (sku) {
          if (scores[sku] !== undefined) scores[sku] += pointMap[sku];
        });
      });
    });

    var ranked = Object.keys(scores)
      .map(function (sku) {
        return Object.assign({ sku: sku, score: scores[sku] }, SKUS[sku]);
      })
      .sort(function (a, b) { return b.score - a.score; });

    return { scores: scores, ranked: ranked };
  }

  function getRecommendations(answers, topN) {
    topN = topN || 2;
    var ranked = scoreQuiz(answers).ranked;
    var picks = [ranked[0]];
    var timing = answers.q4_timing;

    if ((timing === 'both' || timing === 'ritual' || answers.q8_steps === 'ritual') && topN >= 2) {
      var firstTime = picks[0].time;
      var complement = ranked.filter(function (r) {
        return r.sku !== picks[0].sku && r.time !== firstTime && r.time !== 'Anytime';
      })[0] || ranked[1];
      picks.push(complement);
    } else if (topN >= 2) {
      picks.push(ranked[1]);
    }

    return picks.slice(0, topN);
  }

  function buildResultSummary(answers, picks) {
    var skinTypeMap = {
      oily: 'Oily or acne-prone', combo: 'Combination', normal: 'Normal / balanced',
      dry: 'Dry or dehydrated', sensitive: 'Sensitive / easily irritated'
    };
    var goalLabels = {
      brightening: 'Brightening dullness / dark spots', calming: 'Calming redness or sensitivity',
      clearing: 'Clearing breakouts / clogged pores', hydration: 'Deep, lasting hydration',
      barrier: 'Strengthening skin barrier', texture: 'Smoothing tiny bumps / uneven texture',
      firming: 'Firming, overnight repair / fine lines'
    };
    var topGoal = Array.isArray(answers.q3_goals)
      ? goalLabels[answers.q3_goals[0]]
      : (goalLabels[answers.q3_goals] || '—');
    var timingMap = {
      morning: 'Morning only', night: 'Night only', both: 'Morning and night', whenever: 'Whenever I remember'
    };

    return {
      primaryGel: picks[0],
      secondaryGel: picks[1] || null,
      bullets: [
        'You chose "' + (skinTypeMap[answers.q2_skin_type] || answers.q2_skin_type) + '".',
        'Top goal: ' + topGoal + '.',
        'You usually apply skincare: ' + (timingMap[answers.q4_timing] || answers.q4_timing) + '.'
      ]
    };
  }

  /* ============================================================
     UI CONTROLLER
     ============================================================ */
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function QuizApp(root) {
    this.root = root;
    var cfgEl = root.querySelector('[data-quiz-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }
    this.cfg = cfg;
    this.products = cfg.products || {};
    this.answers = {};
    this.step = 0;            // 0..QUESTIONS.length-1, then 'email', then 'results'
    this.phase = 'intro';     // intro | question | email | results
    this.render();
  }

  QuizApp.prototype.render = function () {
    if (this.phase === 'intro') return this.renderIntro();
    if (this.phase === 'question') return this.renderQuestion();
    if (this.phase === 'email') return this.renderEmail();
    if (this.phase === 'results') return this.renderResults();
  };

  QuizApp.prototype.renderIntro = function () {
    var c = this.cfg;
    this.root.innerHTML =
      '<div class="quiz-card quiz-intro">' +
        (c.intro_eyebrow ? '<p class="quiz-eyebrow">' + esc(c.intro_eyebrow) + '</p>' : '') +
        '<h1 class="quiz-h1">' + esc(c.intro_heading || 'Find your gel') + '</h1>' +
        (c.intro_text ? '<p class="quiz-lede">' + esc(c.intro_text) + '</p>' : '') +
        '<button type="button" class="quiz-btn" data-start>' + esc(c.start_label || 'Start the quiz') + '</button>' +
        '<p class="quiz-meta">' + QUESTIONS.length + ' quick questions · about a minute</p>' +
      '</div>';
    var self = this;
    this.root.querySelector('[data-start]').addEventListener('click', function () {
      self.phase = 'question'; self.step = 0; self.render(); self.focusTop();
    });
  };

  QuizApp.prototype.renderQuestion = function () {
    var q = QUESTIONS[this.step];
    var total = QUESTIONS.length;
    var pct = Math.round(((this.step) / total) * 100);
    var selected = this.answers[q.id] || (q.type === 'multi' ? [] : null);
    var inputType = q.type === 'multi' ? 'checkbox' : 'radio';

    var opts = q.options.map(function (o) {
      var isSel = q.type === 'multi' ? selected.indexOf(o.value) !== -1 : selected === o.value;
      return '<label class="quiz-opt' + (isSel ? ' is-selected' : '') + '">' +
        '<input type="' + inputType + '" name="' + esc(q.id) + '" value="' + esc(o.value) + '"' + (isSel ? ' checked' : '') + '>' +
        '<span class="quiz-opt-box" aria-hidden="true"></span>' +
        '<span class="quiz-opt-label">' + esc(o.label) + '</span>' +
      '</label>';
    }).join('');

    this.root.innerHTML =
      '<div class="quiz-card">' +
        '<div class="quiz-progress"><span class="quiz-progress-bar" style="width:' + pct + '%"></span></div>' +
        '<p class="quiz-step">Question ' + (this.step + 1) + ' of ' + total + '</p>' +
        '<h2 class="quiz-q">' + esc(q.question) + '</h2>' +
        '<div class="quiz-opts" role="group">' + opts + '</div>' +
        '<p class="quiz-error" data-error hidden></p>' +
        '<div class="quiz-nav">' +
          (this.step > 0 ? '<button type="button" class="quiz-btn quiz-btn--ghost" data-back>Back</button>' : '<span></span>') +
          '<button type="button" class="quiz-btn" data-next>' + (this.step === total - 1 ? 'See results' : 'Next') + '</button>' +
        '</div>' +
      '</div>';

    this.bindQuestion(q);
  };

  QuizApp.prototype.bindQuestion = function (q) {
    var self = this;
    var card = this.root;
    var inputs = Array.prototype.slice.call(card.querySelectorAll('input[name="' + q.id + '"]'));

    function syncSelectedClasses() {
      inputs.forEach(function (inp) {
        inp.closest('.quiz-opt').classList.toggle('is-selected', inp.checked);
      });
    }

    inputs.forEach(function (inp) {
      inp.addEventListener('change', function () {
        if (q.type === 'multi' && q.maxSelect) {
          var checked = inputs.filter(function (i) { return i.checked; });
          if (checked.length > q.maxSelect) { inp.checked = false; }
          var limit = inputs.filter(function (i) { return i.checked; }).length >= q.maxSelect;
          inputs.forEach(function (i) { if (!i.checked) i.disabled = limit; });
        }
        hideError();
        syncSelectedClasses();
      });
    });

    function hideError() {
      var e = card.querySelector('[data-error]');
      if (e) { e.hidden = true; e.textContent = ''; }
    }
    function showError(msg) {
      var e = card.querySelector('[data-error]');
      if (e) { e.hidden = false; e.textContent = msg; }
    }

    // init disabled state for multi at max
    if (q.type === 'multi' && q.maxSelect) {
      var atMax = inputs.filter(function (i) { return i.checked; }).length >= q.maxSelect;
      inputs.forEach(function (i) { if (!i.checked) i.disabled = atMax; });
    }

    var backBtn = card.querySelector('[data-back]');
    if (backBtn) backBtn.addEventListener('click', function () {
      self.step--; self.phase = 'question'; self.render(); self.focusTop();
    });

    card.querySelector('[data-next]').addEventListener('click', function () {
      var checked = inputs.filter(function (i) { return i.checked; }).map(function (i) { return i.value; });
      if (checked.length === 0) { showError('Please choose an option to continue.'); return; }
      self.answers[q.id] = q.type === 'multi' ? checked : checked[0];

      if (self.step === QUESTIONS.length - 1) {
        self.phase = self.cfg.collect_email ? 'email' : 'results';
        self.render(); self.focusTop();
      } else {
        self.step++; self.render(); self.focusTop();
      }
    });
  };

  // Locale-aware Shopify contact endpoint (handles /en, /fr-ca, etc. storefronts).
  function contactUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'contact';
  }

  QuizApp.prototype.renderEmail = function () {
    var c = this.cfg;
    var self = this;

    // NOTE: deliberately NOT a <form>. A real form lets the browser submit/reload
    // (you'd see ?contact[tags]=quiz&form_type=customer in the URL). We POST via fetch.
    this.root.innerHTML =
      '<div class="quiz-card quiz-email">' +
        '<div class="quiz-progress"><span class="quiz-progress-bar" style="width:100%"></span></div>' +
        '<h2 class="quiz-q">' + esc(c.email_heading || 'Where should we send your routine?') + '</h2>' +
        (c.email_text ? '<p class="quiz-lede">' + esc(c.email_text) + '</p>' : '') +
        '<input type="email" class="quiz-input" data-quiz-email placeholder="' + esc(c.email_placeholder || 'you@email.com') + '" autocomplete="email">' +
        '<p class="quiz-error" data-error hidden></p>' +
        '<div class="quiz-email-actions">' +
          '<button type="button" class="quiz-btn quiz-btn--ghost" data-back>Back</button>' +
          '<button type="button" class="quiz-btn" data-submit>' + esc(c.email_button || 'Reveal my routine') + '</button>' +
        '</div>' +
        (c.require_email ? '' : '<button type="button" class="quiz-skip" data-skip>Skip for now</button>') +
      '</div>';

    function showError(msg) {
      var e = self.root.querySelector('[data-error]');
      if (e) { e.hidden = false; e.textContent = msg; }
    }

    this.root.querySelector('[data-back]').addEventListener('click', function () {
      self.phase = 'question'; self.step = QUESTIONS.length - 1; self.render(); self.focusTop();
    });
    var skip = this.root.querySelector('[data-skip]');
    if (skip) skip.addEventListener('click', function () { self.finish(''); });

    var input = this.root.querySelector('[data-quiz-email]');
    var submitBtn = this.root.querySelector('[data-submit]');

    function submit() {
      var email = (input && input.value || '').trim();
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (!valid) {
        if (self.cfg.require_email) { showError('Please enter a valid email address.'); return; }
        self.finish(''); // optional email left blank — continue without saving
        return;
      }

      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Saving…'; }

      // Shopify customer signup via the same endpoint {% form 'customer' %} uses.
      // urlencoded body matches the native form encoding; tagged "quiz".
      var body = new URLSearchParams();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', email);
      body.append('contact[tags]', 'quiz');

      var done = function () { self.finish(email); };
      try {
        fetch(contactUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
          body: body.toString()
        }).then(done, done);
      } catch (err) {
        done();
      }
    }

    if (submitBtn) submitBtn.addEventListener('click', submit);
    if (input) input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submit(); }
    });
  };

  QuizApp.prototype.finish = function (email) {
    this.email = email || '';
    this.phase = 'results';
    this.render();
    this.focusTop();
  };

  QuizApp.prototype.card = function (pick, isPrimary) {
    if (!pick) return '';
    var p = this.products[pick.sku] || null;
    var img = p && p.image ? p.image : null;
    var url = p && p.url ? p.url : (this.cfg.shop_all_url || '#');
    var price = p && p.price ? p.price : '';
    return '<a class="quiz-rec' + (isPrimary ? ' quiz-rec--primary' : '') + '" href="' + esc(url) + '">' +
      '<div class="quiz-rec-media">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(pick.name) + '" loading="lazy">' : '<span class="quiz-rec-ph"></span>') +
        '<span class="quiz-rec-time">' + esc(pick.time) + '</span>' +
      '</div>' +
      '<div class="quiz-rec-body">' +
        (isPrimary ? '<span class="quiz-rec-tag">Best match</span>' : '<span class="quiz-rec-tag quiz-rec-tag--alt">Pairs with</span>') +
        '<h3>' + esc(pick.name) + '</h3>' +
        '<p class="quiz-rec-line">' + esc(pick.tagline) + '</p>' +
        (price ? '<p class="quiz-rec-price">' + esc(price) + '</p>' : '') +
        '<span class="quiz-rec-cta">Shop now →</span>' +
      '</div>' +
    '</a>';
  };

  QuizApp.prototype.renderResults = function () {
    var picks = getRecommendations(this.answers, 2);
    var summary = buildResultSummary(this.answers, picks);
    var c = this.cfg;

    var bullets = summary.bullets.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('');

    this.root.innerHTML =
      '<div class="quiz-card quiz-results">' +
        (c.results_eyebrow ? '<p class="quiz-eyebrow">' + esc(c.results_eyebrow) + '</p>' : '') +
        '<h2 class="quiz-h1">' + esc(c.results_heading || 'Your INDSO routine') + '</h2>' +
        '<ul class="quiz-summary">' + bullets + '</ul>' +
        '<div class="quiz-recs">' +
          this.card(summary.primaryGel, true) +
          this.card(summary.secondaryGel, false) +
        '</div>' +
        (c.results_footnote ? '<p class="quiz-meta">' + esc(c.results_footnote) + '</p>' : '') +
        '<button type="button" class="quiz-btn quiz-btn--ghost" data-restart>Retake the quiz</button>' +
      '</div>';

    var self = this;
    this.root.querySelector('[data-restart]').addEventListener('click', function () {
      self.answers = {}; self.step = 0; self.email = ''; self.phase = 'intro'; self.render(); self.focusTop();
    });
  };

  QuizApp.prototype.focusTop = function () {
    try { this.root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
  };

  function init() {
    document.querySelectorAll('[data-indso-quiz]').forEach(function (root) {
      if (root.__quizInit) return;
      root.__quizInit = true;
      new QuizApp(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when added/edited in the theme editor
  document.addEventListener('shopify:section:load', init);

  // Expose engine for debugging/tests
  window.IndsoQuiz = { scoreQuiz: scoreQuiz, getRecommendations: getRecommendations, buildResultSummary: buildResultSummary, QUESTIONS: QUESTIONS, SKUS: SKUS };
})();
